var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 37.5007C75 58.2105 58.209 75 37.5 75C16.7895 75 0 58.2105 0 37.5007C0 16.7895 16.7895 0 37.5 0C58.209 0 75 16.7895 75 37.5007",
    fill: "#273B49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 60.7502C41.4885 60.7502 44.7135 57.7007 45.6697 53.9927H29.136C30.0922 57.7007 33.5115 60.7502 37.5 60.7502Z",
    fill: "#019ED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8263 47.1613C54.5753 47.1613 54.5415 40.6101 54.5415 40.6101V32.0938C54.5415 24.8608 50.0978 18.6793 43.8083 16.1293C43.8105 16.0678 43.83 16.0116 43.83 15.9501C43.83 12.9778 40.9523 10.5688 37.4025 10.5688C33.8528 10.5688 30.9758 12.9778 30.9758 15.9501C30.9758 16.0116 30.9945 16.0678 30.9968 16.1293C24.7073 18.6793 20.2635 24.8608 20.2635 32.0938V40.6101C20.2635 40.6101 20.2635 47.1613 15.9788 47.1613C15.9788 47.1613 12.765 47.2288 12.765 51.4663C12.765 53.2491 14.4315 53.9923 16.206 53.9923H26.9183H29.0603H46.1993H48.342H59.0535C60.828 53.9923 62.04 53.2491 62.04 51.4663C62.04 47.2288 58.8263 47.1613 58.8263 47.1613Z",
    fill: "#FFD110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9fe640a2d789f8e89d04ac38e015ba22.svg";
export { ForwardRef as ReactComponent };